import React from "react";
import BrandAssetPage from "../../components/BrandAsset";

const BrandAsset = () => {
  return <BrandAssetPage />;
};

export default BrandAsset;
